import React from "react";
import { Link } from "react-router-dom";

import { Page, Container } from "../elements";

export const PrivacyPolicyPage = () => (
  <Page title="Privacy Policy" className="privacy-policy">
    <main>
      <Container>
        <p>
          <Link to="/">&larr; Torna alla Home</Link>
        </p>
        <h1>
          Informativa in materia di protezione dei dati personali
          <br />
          <small>
            <small>
              <small>ai sensi del Regolamento UE 679/2016</small>
            </small>
          </small>
        </h1>
        <p>
          Youcan srl ssd, con sede legale in Via Ugoni 15 Milano, in qualità di
          titolare del trattamento dei dati personali, in adempimento
          all'obbligo di informare gli interessati sugli elementi fondamentali
          del trattamento dei dati personali, informa specificando di seguito le
          finalità dei trattamenti di dati personali.
        </p>
        <h3>Finalità del trattamento</h3>
        <p>
          Il Titolare del trattamento dei dati personali, è tenuto ad informarLa
          sul trattamento dei Sui dati personali raccolti durante la navigazione
          su questo sito.
          <br />
          Di seguito sono riportate le informative inerenti:
        </p>
        <ul>
          <li>
            Il trattamento dei dati raccolti in maniera automatica con la
            Navigazione Internet;
          </li>
        </ul>
        <h3>Dati raccolti in maniera automatica</h3>
        <p>
          Rispetto ai dati di navigazione: l'accesso a questo sito web,
          attraverso l'uso dei protocolli di comunicazione di Internet, rende
          implicita la trasmissione dei dati personali necessari al collegamento
          medesimo.
        </p>
        <p>
          In particolare in questo sito sono raccolti in maniera automatica i
          seguenti dati di navigazione:
        </p>
        <p>
          <em>Rispetto all’IP Address:</em> sono raccolti con la finalità di
          effettuare controlli sulla provenienza delle informazioni che gli
          utenti comunicano attraverso la compilazione dei form messi a
          disposizione sul sito per la richiesta di servizi.
        </p>
        <p>
          <em>Rispetto a Cookies:</em> sono utilizzati cookies di sessione per
          il salvataggio temporaneo di informazioni necessarie alla navigazione
          del sito (ad esempio la lingua di navigazione, autenticazione in area
          clienti, ecc.) e cookies di terze parti.
        </p>
        <h3>Cookies di terze parti</h3>
        <ul>
          <li>
            <h4>Google Analytics (.google.com)</h4>
            <p>
              Il sito utilizza Google Analytics. Si tratta di un servizio di
              analisi web fornito da Google Inc. (“Google”) che utilizza dei
              cookie che vengono depositati sul computer dell’utente per
              consentire analisi statistiche in forma aggregata sull’utilizzo
              del sito web visitato. Google Analytics è uno strumento che aiuta
              i proprietari di siti web a misurare come gli utenti interagiscono
              con i contenuti del sito. Quando l’utente naviga tra le pagine
              web, Google Analytics tramite l’utilizzo di librerie JavaScript
              registra informazioni sulla pagina che l’utente ha visitato come
              ad esempio, l’URL della pagina. Le librerie JavaScript di Google
              Analytics utilizzano cookie per “ricordare” ciò che un utente ha
              fatto nelle pagine precedenti e le interazioni con il sito web.
              Google Analytics non memorizza alcuna informazione personale sugli
              utenti del sito.
              <a href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage">
                Cookie Policy
              </a>
            </p>
            <ul>
              <li>_ga</li>
              <li>_gat</li>
              <li>__utma</li>
              <li>__utmb</li>
              <li>__utmc</li>
              <li>__utmt</li>
              <li>__utmv</li>
              <li>__utmz</li>
            </ul>
          </li>
        </ul>
        <h3>Disabilitazione dei cookie</h3>
        <p>
          Fermo restando quanto sopra indicato in ordine ai cookie strettamente
          necessari alla navigazione, l’utente può eliminare gli altri cookie
          attraverso la funzionalità a tal fine messa a disposizione dal
          Titolare tramite la presente informativa oppure direttamente tramite
          il proprio browser. Ciascun browser presenta procedure diverse per la
          gestione delle impostazioni. L’utente può ottenere istruzioni
          specifiche attraverso i link sottostanti.
        </p>
        <ul>
          <li>
            <a href="https://windows.microsoft.com/it-it/windows7/block-enable-or-allow-cookies">
              Microsoft Windows Explorer
            </a>
          </li>
          <li>
            <a href="https://support.google.com/chrome/bin/answer.py?hl=it&answer=95647&p=cpn_cookies">
              Google Chrome
            </a>
          </li>
          <li>
            <a href="https://support.mozilla.org/it-IT/kb/Enabling%20and%20disabling%20cookies">
              Mozilla Firefox
            </a>
          </li>
          <li>
            <a href="https://support.apple.com/kb/PH17191?viewlocale=it_IT&locale=it_IT">
              Apple Safari
            </a>
          </li>
          <li>
            <a href="https://www.opera.com/help/tutorials/security/privacy/">
              Opera
            </a>
          </li>
        </ul>
        <p>
          La disattivazione dei cookie di terze parti è inoltre possibile
          attraverso le modalità rese disponibili direttamente dalla società
          terza titolare per detto trattamento, come indicato ai link riportati
          nel paragrafo “cookie di terze parti”. Per avere informazioni sui
          cookie archiviati sul proprio terminale e disattivarli singolarmente
          si rinvia ai seguenti link:&nbsp;
          <a href="http://www.youronlinechoices.com/it/le-tue-scelte">
            http://www.youronlinechoices.com/it/le-tue-scelte
          </a>
           e 
          <a href="http://www.allaboutcookies.org/">
            http://www.allaboutcookies.org/
          </a>
          .
        </p>
        <p>
          I dati personali trattati nel presente sito non sono soggetti a
          diffusione.
        </p>
        <h3>Diritti riconosciuti all’interessato</h3>
        <p>
          L’interessato ha il diritto in qualunque momento di esercitare i
          diritti di cui all’art. 15, 16, 17, 18, 19, 20, 21 e 22 del
          Regolamento UE 679/2016. In particolare ha il diritto di ottenere la
          conferma dell'esistenza o meno dei dati conferiti (contenuto e
          origine), verificarne le finalità del trattamento, i destinatari o le
          categorie di destinatari a cui i dati personali sono o saranno
          comunicati, il periodo di conservazione, ha il diritto di chiedere la
          rettifica, la cancellazione o la limitazione del trattamento, il
          diritto di porre reclamo a un autorità di controllo, l’esistenza di un
          processo decisionale automatizzato e la logica utilizzata, il diritto
          all’oblio, alla portabilità e di sapere se sono trasmessi ad un paese
          terzo.
        </p>
        <p>
          Per l’esercizio dei propri diritti l’interessato può rivolgersi ai
          Titolare del trattamento scrivendo a&nbsp;
          <a href="company@youcan.srl">company@youcan.srl</a>.
        </p>
      </Container>
    </main>
  </Page>
);



// WEBPACK FOOTER //
// ./src/ui/pages/PrivacyPolicyPage.js